import type { UserStatsResponseAchievementsItem } from './userStatsResponseAchievementsItem';
import type { UserStatsResponseBadgesItem } from './userStatsResponseBadgesItem';

export interface UserStatsResponse {
  achievements?: UserStatsResponseAchievementsItem[];
  badges?: UserStatsResponseBadgesItem[];
  /** 마지막 활동 시간 */
  lastActivityAt?: string;
  /** 평판 점수 */
  reputation?: number;
  /** 작성한 댓글 수 */
  totalComments?: number;
  /** 팔로워 수 */
  totalFollowers?: number;
  /** 팔로잉 수 */
  totalFollowing?: number;
  /** 받은 좋아요 수 */
  totalLikes?: number;
  /** 작성한 게시물 수 */
  totalPosts?: number;
  /** 프로필 조회 수 */
  totalViews?: number;
  userId?: string;
}
